import { StyleSheet } from "react-native";
import theme from "../theme";
import { dynamicSize, hexToRgba } from "../helpers";

export default StyleSheet.create({
	statusBar: {
		flex: 0,
		backgroundColor: theme.colors.black,
	},
	safeArea: {
		flex: 1,
		width: null,
		height: null,
		// backgroundColor: theme.colors.grey3
		backgroundColor: theme.colors.grey2,
	},
	container: {
		flex: 1,
		width: null,
		height: null,
	},
	navbarContainer: {
		height: dynamicSize(44),
		backgroundColor: theme.colors.grey2,
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		paddingLeft: dynamicSize(15),
		paddingRight: dynamicSize(15),
		zIndex: 99,
	},
	navbarLeft: {
		flexDirection: "row",
		justifyContent: "flex-start",
		alignItems: "center",
		zIndex: 2,
	},
	navbarCenter: {
		position: "absolute",
		left: 50,
		right: 50,
		top: 0,
		bottom: 0,
		justifyContent: "center",
		alignItems: "center",
		zIndex: 1,
	},
	navbarRight: {
		flexDirection: "row",
		justifyContent: "flex-end",
		alignItems: "center",
		zIndex: 2,
	},
	navbarImage: {
		width: dynamicSize(22),
		height: dynamicSize(22),
	},
	holder1: {
		flex: 1,
		backgroundColor: theme.colors.grey3,
		paddingVertical: dynamicSize(36),
		paddingHorizontal: dynamicSize(24),
		justifyContent: "center",
	},
	holder2: {
		flex: 1,
		backgroundColor: theme.colors.grey2,
	},
	holder3: {
		flex: 1,
		backgroundColor: theme.colors.grey3,
		position: "relative",
	},
	listItem: {
		backgroundColor: theme.colors.grey2,
	},
	loadingOverlay: {
		flex: 1,
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		backgroundColor: "transparent",
		justifyContent: "center",
		alignItems: "center",
	},
	loadingBox: {
		backgroundColor: theme.colors.black,
		justifyContent: "center",
		alignItems: "center",
		width: dynamicSize(60),
		height: dynamicSize(60),
		borderRadius: dynamicSize(5),
		padding: 0,
		margin: 0,
		opacity: 0.8,
	},
	tabBar: {
		backgroundColor: hexToRgba(theme.colors.grey2, 0.95),
		shadowColor: theme.colors.black,
		shadowOpacity: 0.57,
		shadowRadius: 1,
		shadowOffset: { width: 0, height: -2 },
		height: dynamicSize(55),
	},
	tabBarIcon: {
		width: dynamicSize(25),
		height: dynamicSize(25),
	},
	menuIcon: {
		width: dynamicSize(15),
		height: dynamicSize(13),
	},
	logoContainer: {
		// marginLeft: dynamicSize(5),
	},
	logo: {
		// width: dynamicSize(35),
		// height: dynamicSize(18),
		width: 120,
		height: 34,
	},
	logoFlame: {
		// width: dynamicSize(35),
		// height: dynamicSize(18),
		width: 30,
		height: 28,
	},
	logoText: {
		// width: dynamicSize(35),
		// height: dynamicSize(18),
		width: 74,
		height: 28,
		marginTop: 2,
		marginLeft: 3,
	},
	appDisplayName: {
		color: theme.colors.orange,
		fontSize: dynamicSize(14),
		marginLeft: 8,
		marginTop: 4,
	},
	askIcon: {
		width: dynamicSize(40),
		height: dynamicSize(40),
	},
	PSicon: {
		width: dynamicSize(110),
		height: dynamicSize(109),
	},
	appSubBar: {
		backgroundColor: theme.colors.black,
		height: dynamicSize(48),
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingHorizontal: dynamicSize(16),
		shadowColor: theme.colors.black,
		shadowOpacity: 0.5,
		shadowRadius: 2,
		shadowOffset: { width: 0, height: 2 },
	},
	appSubBarLeft: {
		flexDirection: "row",
		alignItems: "center",
		height: "100%",
	},
	appMenuBackground: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		width: "100%",
		height: "100%",
		backgroundColor: "transparent",
		zIndex: 1000,
	},
	appMenuContainer: {
		flex: 1,
		width: dynamicSize(300),
		height: null,
		backgroundColor: theme.colors.black,
		borderWidth: 1,
		borderColor: theme.colors.menuWrapperBorder,
		shadowColor: theme.colors.black,
		shadowOpacity: 0.5,
		shadowRadius: 2,
		shadowOffset: { width: 4, height: 2 },
	},
	appMenuClose: {
		// width: dynamicSize(22),
		// height: dynamicSize(22),
		paddingHorizontal: dynamicSize(12),
		paddingVertical: dynamicSize(16),
	},
});
